import { atom } from "recoil";
import { School } from "../apis";

const KEY = "user-school-list";

export const UserSchoolListAtom = atom<School[]>({
    key: KEY,
    default: [],
});
